<script lang="ts" setup>
import type { EsProductFragment } from '#graphql-operations'

const props = defineProps<{
  relatedProducts: {
    position: string
    block_title: string
    items: {
      sku: string
      product: EsProductFragment
    }[]
  }
}>()

const products = computed(() => props.relatedProducts.items.map(item => item.product))

const combineWithCarousel = useTemplateRef('combineWithCarousel')
</script>

<template>
  <div
    v-if="products.length"
    class="combine-with"
  >
    <div class="combine-with__header">
      <div
        class="combine-with__heading"
        v-text="relatedProducts.block_title"
      />

      <div
        v-if="products.length > 1"
        class="combine-with__navigation"
      >
        <button
          type="button"
          class="combine-with__button combine-with__button--prev"
          :disabled="combineWithCarousel?.arrivedState?.left"
          @click="combineWithCarousel?.scrollToPrev"
        >
          <NuxtIcon
            name="icon:arrow"
            class="icon:arrow-left"
          />
        </button>
        <button
          type="button"
          class="combine-with__button combine-with__button--next"
          :disabled="combineWithCarousel?.arrivedState?.right"
          @click="combineWithCarousel?.scrollToNext"
        >
          <NuxtIcon
            name="icon:arrow"
            class="icon:arrow-right"
          />
        </button>
      </div>
    </div>

    <UiCarousel
      ref="combineWithCarousel"
      class="combine-with__carousel"
    >
      <template
        v-for="(product, productIndex) in products"
        #[`slide-${productIndex}`]
        :key="product.sku"
      >
        <ProductTile
          class="combine-with__product-item product-item--horizontal"
          :product="product"
          :show-options="{ wishlist: true, colorVariants: false, labels: false }"
        >
          <template #additional>
            <ProductActionEs
              class="product-item__add-to-cart"
              :product="product"
            />
          </template>
        </ProductTile>
      </template>
    </UiCarousel>
  </div>
</template>

<style>
@import url("~layers/components/Product/CombineWith.css");
</style>
